import { ControlReference } from "../ControlDispatcher/ControlReference";
import { AbsoluteModelPath } from "../../../../../Common/ModelPath/ModelPath";

export interface ICandyComponentHandle {
    focus(path?: unknown): void;
    makePathAvailableForFocus(path: AbsoluteModelPath): Promise<void>;
    getAnchorElement(): HTMLElement | undefined;
    getTargetBoundingClientRect(): DOMRect | undefined;
}

export function isCandyComponentHandle(ref: ControlReference): ref is ICandyComponentHandle {
    return "getTargetBoundingClientRect" in ref;
}
